import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

import { nsLayoutStyles } from '../../../../../ns-styles/index.js';

import NSJobComponent from '../../../job.js';

import Company from '../../../../../models/company.js';
import JobSchema from '../../../../../models/job-schema.js';

import { formatTurnoverAmount, formatTurnoverDate } from '../../../../../helpers/turnover-format.js';

import '../../../../../ns-elements/ns-job-layout.js';
import '../../../../../ns-elements/ns-detail-list.js';
import definition from '@job-schemas/company/turnover/confirmed-notice.json';
import { jobSchema } from '../../../job-schema.js';

@customElement(NSCompanyTurnoverConfirmedNotice.is)
export default class NSCompanyTurnoverConfirmedNotice extends NSJobComponent {
  static get is() {
    return 'ns-company-turnover-confirmed-notice';
  }

  @state()
  private __company?: Company;

  static get schema(): JobSchema {
    return jobSchema(definition, {
      outcomes: { complete: { type: 'button', label: 'Complete' } },
    });
  }

  static styles = [nsLayoutStyles, ...super.styles];

  async connectedCallback() {
    if (!this._job || !this._job.id) {
      this.triggerCardError('Unable to find job card');
      return;
    }

    try {
      await super.connectedCallback();

      if (!this._db) throw new Error('Unable to find db service');

      this.__company = await this.loadJobCompany();
    } catch (err: unknown) {
      this.showError(err);
    }
  }

  async _outcomeCompleteHandler() {
    if (!this._job || !this._job.id) {
      this.triggerCardError('Unable to find job card');
      return;
    }

    this.clearError();

    try {
      this.loading('Continuing');
      await this.outcome('complete');
      this.loaded();
    } catch (err: unknown) {
      this.loaded();
      this.showError(err);
    }
  }

  render() {
    const turnover = this.__company?.turnover;

    return html`
      <ns-job-layout
        image="/images/jobs/companies-house-verification.svg"
        image-label="Companies House filing illustration"
      >
        <div class="job-panel">
          <ns-detail-list
            .rows=${[
              { label: 'Turnover on record', value: formatTurnoverAmount(turnover) },
              { label: 'For the year ending', value: formatTurnoverDate(turnover?.year) },
            ]}
          ></ns-detail-list>
        </div>
        <div slot="aside" class="primary-info">
          <span class="info-icon" aria-hidden="true">i</span>
          <p>
            We've checked, and this matches ${this.__company?.name ?? 'your company'}'s current Companies House record.
            If you believe this is wrong, you'll need to update it directly with Companies House — until then, we'll use
            this figure for your account.
          </p>
        </div>
      </ns-job-layout>
    `;
  }
}
